// EU banks chosen specifically so their BIC matches `bankAvatarLogoMap`
// in libs/react-components/src/lib/Avatar/BankAvatar.tsx — that way our
// account list shows the real bank logo (not the generic IconBank fallback).
export type DemoBank = {
  name: string;
  bic: string;
  country: "AT" | "CZ" | "DE" | "PL" | "GB";
  defaultCurrency: "EUR" | "CZK" | "PLN" | "USD" | "GBP";
};

export const DEMO_BANKS = {
  // Austria
  bawag: {
    name: "BAWAG P.S.K.",
    bic: "BAWAATWW",
    country: "AT",
    defaultCurrency: "EUR",
  },
  erste: {
    name: "Erste Bank",
    bic: "GIBAATWW",
    country: "AT",
    defaultCurrency: "EUR",
  },
  raiffeisenAt: {
    name: "Raiffeisen Bank International AG",
    bic: "RZBAATWW",
    country: "AT",
    defaultCurrency: "EUR",
  },
  // Czechia
  kb: {
    name: "Komerční banka, a.s.",
    bic: "KOMBCZPP",
    country: "CZ",
    defaultCurrency: "CZK",
  },
  fio: {
    name: "Fio banka, a.s.",
    bic: "FIOBCZPP",
    country: "CZ",
    defaultCurrency: "CZK",
  },
  csob: {
    name: "ČSOB, a.s.",
    bic: "CEKOCZPP",
    country: "CZ",
    defaultCurrency: "CZK",
  },
  csas: {
    name: "Česká spořitelna, a.s.",
    bic: "GIBACZPX",
    country: "CZ",
    defaultCurrency: "CZK",
  },
  // Poland — mBank operates pan-EU; we use the registered BIC supported by the logo registry.
  mbank: {
    name: "mBank S.A.",
    bic: "BREXCZPP",
    country: "PL",
    defaultCurrency: "PLN",
  },
  // Germany / Pan-EU fintechs
  n26: {
    name: "N26 Bank AG",
    bic: "NTSBDEB1",
    country: "DE",
    defaultCurrency: "EUR",
  },
  // Pan-EU / UK fintechs
  wise: {
    name: "Wise Europe SA",
    bic: "TRWIBEB1",
    country: "GB",
    defaultCurrency: "GBP",
  },
  revolut: {
    name: "Revolut Bank UAB",
    bic: "REVOLT21",
    country: "GB",
    defaultCurrency: "EUR",
  },
} as const satisfies Record<string, DemoBank>;

export type DemoBankKey = keyof typeof DEMO_BANKS;
